import React from "react";
import { Avatar, AvatarGroup, Box, Button, Card, CardContent, Typography } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";

const Img = styled("img")({
  display: "block",
  //   maxWidth: "40%",
  //   maxHeight: "100%",
});

const DefendantCard = ({ classes, handleDefendant, singleProcessData, permission }) => {
  let reu = [];
  singleProcessData?.reu?.map(obj => {
    if (obj?.nome) {
      return reu.push(obj.nome);
    }
  });
  // console.log("reu", reu);

  return (
    <div>
      <Card
        variant="elevation"
        className={classes.card}
        sx={{ background: "#fff", marginBottom: "1rem", borderRadius: "13px", paddingX: 2 }}>
        <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600 }}>Réu:</Typography>

            <Typography sx={{ fontWeight: 500, display: "inline" }}>
              {reu
                ?.filter(obj => obj != null)
                .map((obj, i) => {
                  return (
                    <>
                      <span key={i}>{obj}</span>
                      <br />
                    </>
                  );
                })}
            </Typography>
            <br />
            <Typography sx={{ fontWeight: 500, display: "inline" }}>
              {singleProcessData?.defendant
                ?.filter(obj => obj != null)
                ?.map((obj, i) => {
                  return (
                    <>
                      <span key={i}>{obj}</span>
                      <br />
                    </>
                  );
                })}
            </Typography>
          </Box>
          {permission?.isOwner && permission?.processMgt && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }} onClick={handleDefendant}>
              <Img
                alt="Delete"
                src="/assets/images/lawyers.png"
                width={50}
                height={50}
                sx={{
                  maxWidth: "30px !important",
                  maxHeight: "30px !important",
                  posotion: "absolute",
                  background: "#fff",
                  color: "red",
                  padding: "12px",
                  borderRadius: "13px",
                }}
              />
            </Box>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default DefendantCard;
